import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="depoimentos" className="section-padding bg-gradient-to-b from-gray-900 to-black relative">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
              O que dizem nossos <span className="gradient-text">alunos</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              Histórias reais de quem já transformou sua carreira
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-2 gap-4 md:gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.name}
                className="glass p-5 md:p-6 rounded-xl card-hover relative"
              >
                {/* Quote Icon */}
                <Quote className="absolute top-3 right-3 md:top-4 md:right-4 w-8 h-8 md:w-12 md:h-12 text-yellow-400/20" />

                {/* Rating */}
                <div className="flex gap-1 mb-3 md:mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={`${testimonial.name}-star-${i}`} className="w-4 h-4 md:w-5 md:h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Text */}
                <p className="text-gray-300 text-sm md:text-base mb-5 md:mb-6 leading-relaxed relative z-10">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <div
                    className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                      ['bg-yellow-500', 'bg-green-500', 'bg-blue-500', 'bg-purple-500'][index % 4]
                    }`}
                  >
                    <span className="text-white font-black text-base md:text-lg">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <div className="font-bold text-white text-sm md:text-base">{testimonial.name}</div>
                    <div className="text-xs md:text-sm text-gray-400">{testimonial.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="mt-10 md:mt-12 text-center glass-dark p-5 md:p-8 rounded-2xl">
            <p className="text-gray-300 text-base md:text-lg mb-4">
              Junte-se a centenas de profissionais que já dominam a Console WING
            </p>
            <a
              href="#inscricao"
              className="inline-block w-full sm:w-auto bg-yellow-500 hover:bg-yellow-600 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold transition-all duration-300 hover:scale-105 glow-yellow"
            >
              EU QUERO FAZER PARTE
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
